/** @internal */
const make = (label, startTime) => ({
  label,
  startTime
});

/** @internal */
const render = now => {
  return self => {
    const label = self.label.replace(/[\s="]/g, "_");
    return `${label}=${now - self.startTime}ms`;
  };
};

export { make, render };
